import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reportFill" }
const _hoisted_2 = {
  align: "left",
  style: {"padding-left":"100px","padding-bottom":"5px","padding-top":"20px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  slot: "default",
  class: "el-icon-plus"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "支持 jpeg, jpg, png 格式，不超过20m", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  slot: "default",
  class: "el-icon-plus"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "支持 jpeg, jpg, png 格式，不超过20m", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "支持 mp3, mkv, wma 格式，不超过50m", -1)

import { basicFormConfig } from "./config/form.config";
import { useRoute } from "vue-router";
import { reactive, ref } from "vue";
import BasicForm from "@/components/BasicForm.vue";
import { ElMessageBox } from "element-plus";
import { editPageData } from "@/service/main/system";
import { useUpload } from "@/hooks/useUpload";


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const route = useRoute()
const defaultInfo = ref({})
defaultInfo.value = route.query
const basicFormRef = ref<InstanceType<typeof BasicForm>>()
const handleSelect = (value: any)=> {
}

const [uploadRef, extraData, files, action, beforeUpload, proveUpload, onSuccess, onExceed,
  filesMap, proveFiles, records] = useUpload()

const otherInfo = reactive({
  proofImgUrls: '',
  recordingUrls: '',
  proveImgUrls: '',
})

const imgFileList = ref<any[]>([])
if (defaultInfo.value.proofImgUrls != null
  && defaultInfo.value.proofImgUrls != ""
  && defaultInfo.value.proofImgUrls != undefined) {
  const proofImgUrlsArr = defaultInfo.value.proofImgUrls.split(',');
  let uid;
  for (let i = 0; i < proofImgUrlsArr.length; i++) {
    uid = Date.now() + i;
    filesMap.value.set(String(uid), proofImgUrlsArr[i])
    imgFileList.value.push({uid: uid, url: proofImgUrlsArr[i]});
  }
}

const imgProveFileList = ref<any[]>([])
if (defaultInfo.value.proveImgUrls != null
  && defaultInfo.value.proveImgUrls != ""
  && defaultInfo.value.proveImgUrls != undefined) {
  const proveImgUrlsArr = defaultInfo.value.proveImgUrls.split(',');
  let uid;
  for (let i = 0; i < proveImgUrlsArr.length; i++) {
    uid = Date.now() + i;
    proveFiles.value.set(String(uid), proveImgUrlsArr[i])
    imgProveFileList.value.push({uid: uid, url: proveImgUrlsArr[i]});
  }
}

const recordFileList = ref<any[]>([])
if (defaultInfo.value.recordingUrls != null
  && defaultInfo.value.recordingUrls != ""
  && defaultInfo.value.recordingUrls != undefined) {
  records.value.push(defaultInfo.value.recordingUrls)
  recordFileList.value = [
    {
      name: 'recording' + defaultInfo.value.recordingUrls.substring(defaultInfo.value.recordingUrls.lastIndexOf('.')),
      url: defaultInfo.value.recordingUrls
    }
  ]
}

const handleValid = () => {
  otherInfo.proofImgUrls = ''
  otherInfo.recordingUrls = ''
  otherInfo.proveImgUrls = ''

  filesMap.value.forEach((value: string, key: string) => {
    otherInfo.proofImgUrls = otherInfo.proofImgUrls + value + ','
  })
  otherInfo.proofImgUrls = otherInfo.proofImgUrls.slice(0, -1);

  proveFiles.value.forEach((value: string, key: string) => {
    otherInfo.proveImgUrls = otherInfo.proveImgUrls + value + ','
  })
  otherInfo.proveImgUrls = otherInfo.proveImgUrls.slice(0, -1)

  if (records.value.length > 0) {
    otherInfo.recordingUrls = records.value[0]
  }
  return true
}
const handleImgRemove = (uploadFile: any, uploadFiles: any) => {
  debugger
  filesMap.value.delete(String(uploadFile.uid))
}

const handleProveImageRemove = (uploadFile: any, uploadFiles: any) => {
  proveFiles.value.delete(String(uploadFile.uid))
}

let dialogImageUrl = ref()
const dialogVisible = ref(false)
const handlePreview = (file: any) => {
  dialogImageUrl.value = file.url
  dialogVisible.value = true
}

const handleRecordRemove = (uploadFile: any, uploadFiles: any) => {
  records.value.splice(0, records.value.length)
}

const selectValue = ref()
let verifyResultDesc = ref()
verifyResultDesc.value = defaultInfo.value.verifyResultDesc
let showVerifyBtn = ref()
showVerifyBtn.value = defaultInfo.value.verifyResult == '1'
const handleVerify = () => {
  ElMessageBox.confirm('', {
    title: '核实',
    confirmButtonText: '属实',
    cancelButtonText: '不属实',
    distinguishCancelAndClose: true
  }).then((action) => {
    if ('confirm' == action) {
      const formData = basicFormRef.value.getFormData();
      formData.value.verifyResult = '1'
      let pageUrl = `/main/newFundsVerification/verify/${defaultInfo.value.id}/${formData.value.verifyResult}`
      editPageData(pageUrl, {})
      verifyResultDesc.value = '属实'
    }
  }).catch(err => {
    if ('cancel' == err) {
      const formData = basicFormRef.value.getFormData();
      formData.value.verifyResult = "2"
      let pageUrl = `/main/newFundsVerification/verify/${defaultInfo.value.id}/${formData.value.verifyResult}`
      editPageData(pageUrl, {}).then((re) => {
        verifyResultDesc.value = '不属实'
      })
    }
  })
}

const closePage = () => {
  window.close()
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" 业绩核实结果: " + _toDisplayString(_unref(verifyResultDesc)) + " ", 1),
        _createVNode(_component_el_button, {
          hidden: _unref(showVerifyBtn),
          type: "primary",
          size: "medium",
          onClick: handleVerify
        }, {
          default: _withCtx(() => [
            _createTextVNode("核实 ")
          ]),
          _: 1
        }, 8, ["hidden"])
      ]),
      _createVNode(BasicForm, {
        basicFormConfig: _unref(basicFormConfig),
        pageName: "newFundsVerification",
        ref_key: "basicFormRef",
        ref: basicFormRef,
        otherInfo: otherInfo,
        defaultInfo: defaultInfo.value,
        validOtherInfo: handleValid,
        onClosePage: closePage
      }, {
        insert: _withCtx(() => [
          _createVNode(_component_el_upload, {
            ref_key: "uploadRef",
            ref: uploadRef,
            "auto-upload": true,
            action: _unref(action),
            data: _unref(extraData),
            "file-list": imgFileList.value,
            "before-upload": _unref(beforeUpload),
            "on-success": _unref(onSuccess),
            "on-exceed": _unref(onExceed),
            accept: ".jpeg,.jpg,.png",
            "on-remove": handleImgRemove,
            multiple: "",
            "list-type": "picture-card",
            "on-preview": handlePreview,
            disabled: defaultInfo.value.verifyResult==1
          }, {
            tip: _withCtx(() => [
              _hoisted_4
            ]),
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["action", "data", "file-list", "before-upload", "on-success", "on-exceed", "disabled"])
        ]),
        proveInsert: _withCtx(() => [
          _createVNode(_component_el_upload, {
            ref_key: "uploadRef",
            ref: uploadRef,
            "auto-upload": true,
            action: _unref(action),
            data: _unref(extraData),
            "file-list": imgProveFileList.value,
            "before-upload": _unref(proveUpload),
            "on-success": _unref(onSuccess),
            "on-exceed": _unref(onExceed),
            accept: ".jpeg,.jpg,.png",
            "on-remove": handleProveImageRemove,
            multiple: "",
            "list-type": "picture-card",
            "on-preview": handlePreview,
            disabled: defaultInfo.value.verifyResult==1
          }, {
            tip: _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["action", "data", "file-list", "before-upload", "on-success", "on-exceed", "disabled"])
        ]),
        fileInsert: _withCtx(() => [
          _createVNode(_component_el_upload, {
            action: _unref(action),
            data: _unref(extraData),
            "file-list": recordFileList.value,
            accept: ".mp3, .mkv, .wma",
            "on-remove": handleRecordRemove,
            "show-file-list": true,
            limit: 1,
            "auto-upload": true,
            "before-upload": _unref(beforeUpload),
            ref: "recordUpload",
            disabled: defaultInfo.value.verifyResult==1
          }, {
            tip: _withCtx(() => [
              _hoisted_7
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("选择文件")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["action", "data", "file-list", "before-upload", "disabled"])
        ]),
        _: 1
      }, 8, ["basicFormConfig", "otherInfo", "defaultInfo"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "图片预览",
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
      width: "50%",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_image, {
          src: _unref(dialogImageUrl),
          fit: "fit",
          lazy: ""
        }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})